import useWorkflowNavigation from '@/frontend/pages/Dashboard/Workflows/useWorkflowNavigation'
import { Link } from '@inertiajs/react'
import { cn } from '@/lib/utils'
import { displayDate, displayDuration } from '@/frontend/pages/Dashboard/Workflows/presentation'
import type { Copy, RecentExecutions } from '@/frontend/pages/Dashboard/Workflows/types'

export default function WorkflowCurrentExecution({ data, copy }: { data: RecentExecutions; copy: Copy }) {
  const { executionPath } = useWorkflowNavigation()
  const execution = data.latest_execution
  if (!execution) return <p className="text-xs text-muted-foreground">{data.items.length ? copy.catalog.unavailable_status : copy.catalog.no_executions}</p>
  const tone = { running: 'text-[#17709F] dark:text-sky-400', completed: 'text-success', failed: 'text-destructive', canceled: 'text-muted-foreground',
    terminated: 'text-destructive', timed_out: 'text-warning', continued_as_new: 'text-brand' }[execution.status]
  return <div className="space-y-[3px]">
    <Link href={executionPath(execution)} className={cn('inline-flex items-center gap-1.5 rounded-sm text-[13px] font-medium leading-4 hover:underline focus-visible:ring-2 focus-visible:ring-ring', tone)}>
      <span className="size-1.5 shrink-0 rounded-full bg-current" aria-hidden />{copy.execution_states[execution.status]}
    </Link>
    <p className="text-xs leading-4 text-muted-foreground">{displayDate(execution.started_at, copy.shared.not_informed)} · {displayDuration(execution.duration_ms ?? execution.elapsed_ms, copy)}
      {execution.elapsed_ms !== null && <span className="sr-only"> {copy.shared.elapsed}</span>}
    </p>
    {!data.coverage.complete && <p className="text-[11px] leading-4 text-muted-foreground">{copy.catalog.latest_sample}</p>}
  </div>
}
